export default {
  name: '简体中文',
  navigation: {
    home: '首页',
    productSystem: '产品体系',
    groupMembers: '集团成员',
    devHistory: '发展历程',
    onlineMall: '线上商城',
    enterpriseNews: '企业新闻',
    mediaReports: '媒体报道',
    historyMedia: '光阳相册',
    contactUs: '联系我们',
    productSystem2: '产品体系',
    groupMembers2: '集团成员',
    devHistory2: '发展历程',
    onlineMall2: '线上商城',
    enterpriseNews2: '企业新闻',
    contactUs2: '联系我们'
  },
  companyName: '福建光阳蛋业股份有限公司',
  addressName: '地址',
  address: '福建省福州市福清市镜洋镇磨石村朝阳路52号',
  goal1: '对标世界一流',
  goal2: '创造世界一流',
  copyright: '版权所有',
  recordName: '闽ICP备05001758号-2',
  detail: '详情',
  newsDetails: '新闻详情',
  viewOriginalText: '查看原文',
  back: '返回',
  contactNumber: '联系电话',
  contactEmail: '联系邮箱',
  searchReport: '请输入新闻标题',
  share: '分享',
  copySuccess: '链接已复制，可粘贴分享',
  copyFail: '分享失败，请稍后重试',
  albumName: '光阳蛋业相册'
}
